<template>
  <section class="unknown-files container">
    <breadcrumb v-if="isAdminOrCeoRole && !isMobile" crumb="unknown-files" />
    <el-row type="flex" align="middle" justify="space-between">
      <el-select
        v-model="hardware_id"
        v-loading="loadingHardware"
        placeholder="Все терминалы"
        size="small"
        clearable
        class="w-auto"
        @change="fetchList"
      >
        <el-option
          v-for="item in hardwareList"
          :key="item.hardware_public_id"
          :label="item.hardware_name"
          :value="item.hardware_public_id"
        />
      </el-select>
      <el-select
        v-model="sortValue"
        size="small"
        class="w-auto"
        @change="changeSort"
      >
        <el-option
          v-for="item in sortMode"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <p>Всего не разобрано: {{ pagination.totalCount || 0 }}</p>
    </el-row>
    <el-table
      v-if="loading || !unknownDocs.length"
      v-loading="loading"
      :data="unknownDocs"
      element-loading-text="Загрузка..."
    />
    <el-collapse-transition v-if="unknownDocs.length && !loading">
      <section>
        <el-row
          v-for="doc in unknownDocs"
          :key="doc.document_id"
          type="flex"
          align="middle"
          class="unknown-files__row cp"
        >
          <el-col :span="3" class="ta-c" @click.native="generateCurrent(doc)">
            {{ dateToFormat(doc.date, 'respStatusDate') }}
          </el-col>
          <el-col @click.native="generateCurrent(doc)">
            {{ doc.hardware_name }}
          </el-col>
          <el-col
            :span="2"
            class="ta-c"
            @click.native="handleDownload(doc.document_id)"
          >
            <i class="el-icon-download" />
          </el-col>
        </el-row>
        <el-row class="pagination">
          <pagination :data="pagination" @changed="changePage" />
        </el-row>
      </section>
    </el-collapse-transition>
    <unknown-file-modal />
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { sortMode } from './constants'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import Pagination from '@/components/Tables/PaginationCustom'
import UnknownFileModal from './components/UnknownFileModal'

export default {
  name: 'UnknownFiles',
  components: { Pagination, UnknownFileModal, Breadcrumb },
  data() {
    return {
      page: 1,
      files: undefined,
      sortMode,
      sortValue: '',
    }
  },
  computed: {
    ...mapGetters('hardware', [
      'getLoading',
      'unknownDocs',
      'hardwareList',
      'pagination',
      'hardware_public_id',
    ]),
    loading() {
      return this.getLoading()
    },
    loadingHardware() {
      return this.getLoading('Hardware')
    },
    hardware_id: {
      get() {
        return this.hardware_public_id
      },
      set(val) {
        this.setHardwareId(val)
      },
    },
  },
  async mounted() {
    if (!localStorage.getItem('report_sort_mode')) {
      localStorage.setItem('report_sort_mode', sortMode[0].value)
    }
    this.sortValue = localStorage.getItem('report_sort_mode')
    this.fetchHardware()
    this.fetchList()
  },
  methods: {
    ...mapActions('hardware', [
      'fetchUnknownFiles',
      'fetchHardware',
      'generateZipUrl',
      'generateCurrent',
    ]),
    ...mapMutations('hardware', ['setHardwareId']),
    fetchList() {
      this.fetchUnknownFiles({ page: this.page, sort: this.sortValue })
    },
    changePage(page = 1) {
      this.page = page
      this.fetchList()
    },
    changeSort() {
      localStorage.setItem('report_sort_mode', this.sortValue)
      this.fetchList()
    },
    async handleDownload(id) {
      const path = await this.generateZipUrl(id)

      this.downloadRegistry({ path, blank: 1 })
    },
  },
}
</script>

<style lang="sass">
.unknown-files
  &__row
    margin: 20px 0
    background: #fff
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
    .el-col
      padding: 15px 0
</style>
